import { ListItem, SectionHeader, SideOverHeaderNew, SideOverHeading } from '../../components';
import { hiContrastElementsColors } from '../../../util';
import { LocalThemeContextProvider } from '../../context';
import {
  EDUCATION_QUALIFIED_INVESTMENT_TYPES,
  HEALTHCARE_QUALIFIED_INVESTMENT_TYPES,
  OTHER_QUALIFIED_INVESTMENT_TYPES,
  TAX_DEFERRED_QUALIFIED_INVESTMENT_TYPES,
  TAX_FREE_QUALIFIED_INVESTMENT_TYPES,
  displayInvestmentType,
} from '../../../Investment';
import { QualifiedTermElementDetailViewAddQualifiedAssetOptionsPageProps } from './types';
import { useTranslation } from 'react-i18next';

const sections = [
  {
    headerKey: 'qualified-term-element-detail-view-add-qualified-asset-after-tax-investments-section-header',
    investmentTypes: TAX_FREE_QUALIFIED_INVESTMENT_TYPES,
  },
  {
    headerKey: 'qualified-term-element-detail-view-add-qualified-asset-pre-tax-investments-section-header',
    investmentTypes: TAX_DEFERRED_QUALIFIED_INVESTMENT_TYPES,
  },
  {
    headerKey: 'qualified-term-element-detail-view-add-qualified-asset-education-section-header',
    investmentTypes: EDUCATION_QUALIFIED_INVESTMENT_TYPES,
  },
  {
    headerKey: 'qualified-term-element-detail-view-add-qualified-asset-healthcare-section-header',
    investmentTypes: HEALTHCARE_QUALIFIED_INVESTMENT_TYPES,
  },
  {
    headerKey: 'qualified-term-element-detail-view-add-qualified-asset-other-section-header',
    investmentTypes: OTHER_QUALIFIED_INVESTMENT_TYPES,
  },
] as const;

export function QualifiedTermElementDetailViewAddQualifiedAssetOptionsPage({
  clickHandlers,
}: QualifiedTermElementDetailViewAddQualifiedAssetOptionsPageProps) {
  const { t: tPages } = useTranslation('pages');
  const { t: tCommon } = useTranslation('common');
  const { t: tInvestment } = useTranslation('investment');

  return (
    <LocalThemeContextProvider paletteSeedColor={hiContrastElementsColors['Qt']}>
      <SideOverHeaderNew withShadow className="!px-4" exitIcon="back" exitText={tCommon('back')} />
      <div className="px-10">
        <SideOverHeading
          className="md:!mt-[25px] mb-14"
          heading={tPages('qualified-term-element-detail-view-add-qualified-asset-page-heading')}
        />
        {sections.map(({ headerKey, investmentTypes }, sectionIndex) => (
          <div key={headerKey}>
            <SectionHeader className={sectionIndex === 0 ? 'pl-4' : 'pl-4 mt-6'} header={tPages(headerKey)} />
            <div>
              {investmentTypes.map((investmentType) => (
                <ListItem
                  key={investmentType}
                  withChevron={!!clickHandlers?.addQualifiedAsset}
                  onClick={() => clickHandlers?.addQualifiedAsset?.(investmentType)}
                  className="justify-between min-h-12 first:rounded-t-2xl items-center last:rounded-b-2xl pl-4 pr-2 text-white !bg-transparent"
                >
                  {displayInvestmentType(investmentType, tInvestment)}
                </ListItem>
              ))}
            </div>
          </div>
        ))}
      </div>
    </LocalThemeContextProvider>
  );
}
